<template>
  <MainPageBlockWrapperNew
    title="Специальные проекты портала История.РФ"
    href="/special-projects-historyrf"
  >
    <div class="grid gap-5 lg:grid-cols-3">
      <MainPageCardsReworkedBaseCard
        v-for="project in history"
        :key="project.slug"
        :data="project"
        position-image="object-top"
        disable-label
        disable-announce
      />
    </div>
  </MainPageBlockWrapperNew>
</template>

<script setup>
import history from '@/assets/data/special-projects/history';
</script>
